import { useCallback, useState } from 'react';

type Params = {
  readonly disable?: boolean
  readonly id?: string,
  readonly isAsync?: boolean,
  readonly scripts: string[]
}

const useLoadExternalScripts = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [success, setSuccess] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(true);

  const handleExternalScript = useCallback(({
    id = '',
    isAsync = true,
    scripts,
  }: Params) => {
    const loadScript = (url:string) => new Promise<string>((resolve, reject) => {
      const s = document.createElement('script');
      s.async = isAsync;
      s.id = id;
      s.src = url;
      s.onload = () => resolve(url);
      s.onerror = () => reject(url);
      document.body.appendChild(s);
    });

    const promises = [] as Promise<string>[];

    scripts.forEach((url) => {
      promises.push(loadScript(url));
    });

    Promise.all(promises)
      .then(() => {
        setLoading(false);
        setSuccess(true);
        setDisable(false);
      })
      .catch((script) => {
        setLoading(false);
        console.error(`${script} failed to load`); // eslint-disable-line no-console
      });
  }, []);

  return { disable, handleExternalScript, loading, success };
};

export default useLoadExternalScripts;
